import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import classNames from "classnames";

export interface ShippingNotifyProps {
  className?: string;
}

const ShippingNotify: React.FC<ShippingNotifyProps> = () => {
  const { t } = useTranslation();
  return <div className={classNames(styles.root)}>{t("bv6w78euydgfvsfvb.excluding-shipping", "Excluding shipping costs")}</div>;
};

export default ShippingNotify;
